export default class VodPackageService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('vodPackages', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('vodPackages/' + id, params)
	}

	getSimpleList(params) {
		return this.apiService.callGet('vodPackages/simple', params)
	}

    addVodPackagePrice(id, params){
        return this.apiService.callPost('vodPackages/' + id + "/vodPackagePrice", params)
    }

    updateVodPackagePrice(id, params){
        return this.apiService.callPut('vodPackages/' + id + "/vodPackagePrice", params)
    }

    deleteVodPackagePrice(id, params){
        return this.apiService.callDelete('vodPackages/' + id + "/vodPackagePrice", params)
    }
}



// WEBPACK FOOTER //
// ./src/service/VodPackageService.js